// 可视组件通用 API
import jsBridge from "../../common/jsBridge";

export function setViewRect({unitId, id, rect}) {
    let params = {
        unitId,
        id,
        data: {
            rect
        }
    }
    return jsBridge.callNative({fnName: 'VideoBridge/setViewRect', params})
}

export function removeFromSuperView({unitId, id}) {
    let params = {
        unitId,
        id,
        data: {}
    }
    return jsBridge.callNative({fnName: 'VideoBridge/removeFromSuperView', params})
}

export function appendSubView({unitId, parentCmptId, childCmptId, rect}) {
    let params = {
        unitId,
        id: parentCmptId, // 父视图
        data: {
            id: childCmptId, // 子视图
            rect,
            // rect: {top: 0, bottom: 0, left: 0, right: 0} // width 或 height 不传, 则为父视图宽高
        }
    }
    return jsBridge.callNative({fnName: 'VideoBridge/appendSubView', params})
}

export function appendViewTo({unitId, childCmptId, parentCmptId, rect}) {
    let params = {
        unitId,
        id: childCmptId, // 子视图
        data: {
            id: parentCmptId, // 父视图
            rect,
            // rect: {top: 0, bottom: 0, left: 0, right: 0} // width 或 height 不传, 则为父视图宽高
        }
    }
    return jsBridge.callNative({fnName: 'VideoBridge/appendViewTo', params})
}

export function bringViewToFront({unitId, id}) {
    let params = {
        unitId,
        id,
        data: {}
    }
    return jsBridge.callNative({fnName: 'VideoBridge/bringViewToFront', params})
}

export function hideView({unitId, id}) {
    let params = {
        unitId,
        id,
        data: {}
    }
    return jsBridge.callNative({fnName: 'VideoBridge/hideView', params})
}

export function showView({unitId, id}) {
    let params = {
        unitId,
        id,
        data: {}
    }
    return jsBridge.callNative({fnName: 'VideoBridge/showView', params})
}

export function setViewBgColor({unitId, id, color}) {
    let params = {
        unitId,
        id,
        data: {
            color
        }
    }
    return jsBridge.callNative({fnName: 'VideoBridge/setViewBgColor', params})
}

export function setViewAlpha({unitId, id, alpha}) {
    let params = {
        unitId,
        id,
        data: {
            alpha
        }
    }
    return jsBridge.callNative({fnName: 'VideoBridge/setViewAlpha', params})
}

export function setViewScale({unitId, id, vertical, horizon}) {
    let params = {
        unitId,
        id,
        data: {
            vertical,
            horizon,
        }
    }
    return jsBridge.callNative({fnName: 'VideoBridge/setViewScale', params})
}

export function insertViewAbove({unitId, id, targetComponentId, rect}) {
    let params = {
        unitId,
        id, // 当前要参照的视图 id
        data: {
            targetComponentId, // 要插入的视图 id
            rect,
        }
    }
    return jsBridge.callNative({fnName: 'VideoBridge/insertViewAbove', params})
}

export function insertViewBelow({unitId, id, targetComponentId, rect}) {
    let params = {
        unitId,
        id, // 当前要参照的视图 id
        data: {
            targetComponentId, // 要插入的视图 id
            rect,
        }
    }
    return jsBridge.callNative({fnName: 'VideoBridge/insertViewBelow', params})
}